import { render, staticRenderFns } from "./analyze_tab.vue?vue&type=template&id=2a56cad0&scoped=true"
import script from "./analyze_tab.vue?vue&type=script&lang=js"
export * from "./analyze_tab.vue?vue&type=script&lang=js"
import style0 from "./analyze_tab.vue?vue&type=style&index=0&id=2a56cad0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56cad0",
  null
  
)

export default component.exports